export default "assets/images/spotify-2450a50e.svg";